module.exports = __webpack_public_path__ + "assets/img/1.d81ab0e5.jpg";